export default {
  AL: { id: 2, name: 'Alabama', code: 'AL', is_type: 'state' },
  AZ: { id: 4, name: 'Arizona', code: 'AZ', is_type: 'state' },
  AR: { id: 3, name: 'Arkansas', code: 'AR', is_type: 'state' },
  CA: { id: 5, name: 'California', code: 'CA', is_type: 'state' },
  CO: { id: 6, name: 'Colorado', code: 'CO', is_type: 'state' },
  CT: { id: 7, name: 'Connecticut', code: 'CT', is_type: 'state' },
  DE: { id: 9, name: 'Delaware', code: 'DE', is_type: 'state' },
  DC: { id: 8, name: 'District Of Columbia', code: 'DC', is_type: 'state' },
  FL: { id: 10, name: 'Florida', code: 'FL', is_type: 'state' },
  GA: { id: 11, name: 'Georgia', code: 'GA', is_type: 'state' },
  HI: { id: 12, name: 'Hawaii', code: 'HI', is_type: 'state' },
  ID: { id: 14, name: 'Idaho', code: 'ID', is_type: 'state' },
  IL: { id: 15, name: 'Illinois', code: 'IL', is_type: 'state' },
  IN: { id: 16, name: 'Indiana', code: 'IN', is_type: 'state' },
  IA: { id: 13, name: 'Iowa', code: 'IA', is_type: 'state' },
  KS: { id: 17, name: 'Kansas', code: 'KS', is_type: 'state' },
  KY: { id: 18, name: 'Kentucky', code: 'KY', is_type: 'state' },
  LA: { id: 19, name: 'Louisiana', code: 'LA', is_type: 'state' },
  ME: { id: 22, name: 'Maine', code: 'ME', is_type: 'state' },
  MD: { id: 21, name: 'Maryland', code: 'MD', is_type: 'state' },
  MA: { id: 20, name: 'Massachusetts', code: 'MA', is_type: 'state' },
  MI: { id: 23, name: 'Michigan', code: 'MI', is_type: 'state' },
  MN: { id: 24, name: 'Minnesota', code: 'MN', is_type: 'state' },
  MS: { id: 26, name: 'Mississippi', code: 'MS', is_type: 'state' },
  MO: { id: 25, name: 'Missouri', code: 'MO', is_type: 'state' },
  MT: { id: 27, name: 'Montana', code: 'MT', is_type: 'state' },
  NE: { id: 30, name: 'Nebraska', code: 'NE', is_type: 'state' },
  NV: { id: 34, name: 'Nevada', code: 'NV', is_type: 'state' },
  NH: { id: 31, name: 'New Hampshire', code: 'NH', is_type: 'state' },
  NJ: { id: 32, name: 'New Jersey', code: 'NJ', is_type: 'state' },
  NM: { id: 33, name: 'New Mexico', code: 'NM', is_type: 'state' },
  NY: { id: 35, name: 'New York', code: 'NY', is_type: 'state' },
  NC: { id: 28, name: 'North Carolina', code: 'NC', is_type: 'state' },
  ND: { id: 29, name: 'North Dakota', code: 'ND', is_type: 'state' },
  OH: { id: 36, name: 'Ohio', code: 'OH', is_type: 'state' },
  OK: { id: 37, name: 'Oklahoma', code: 'OK', is_type: 'state' },
  OR: { id: 38, name: 'Oregon', code: 'OR', is_type: 'state' },
  PA: { id: 39, name: 'Pennsylvania', code: 'PA', is_type: 'state' },
  RI: { id: 41, name: 'Rhode Island', code: 'RI', is_type: 'state' },
  SC: { id: 42, name: 'South Carolina', code: 'SC', is_type: 'state' },
  SD: { id: 43, name: 'South Dakota', code: 'SD', is_type: 'state' },
  TN: { id: 44, name: 'Tennessee', code: 'TN', is_type: 'state' },
  TX: { id: 45, name: 'Texas', code: 'TX', is_type: 'state' },
  UT: { id: 46, name: 'Utah', code: 'UT', is_type: 'state' },
  VT: { id: 49, name: 'Vermont', code: 'VT', is_type: 'state' },
  VA: { id: 47, name: 'Virginia', code: 'VA', is_type: 'state' },
  WA: { id: 50, name: 'Washington', code: 'WA', is_type: 'state' },
  WV: { id: 52, name: 'West Virginia', code: 'WV', is_type: 'state' },
  WI: { id: 51, name: 'Wisconsin', code: 'WI', is_type: 'state' },
  WY: { id: 53, name: 'Wyoming', code: 'WY', is_type: 'state' },
};
